import React, { useRef, useState, useEffect, useMemo } from "react";
import ArticleCarte from "./ArticleCarte";
import { motion } from "framer-motion";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { imageArticleUrl } from "../../utils/modules";
import "../../assets/css/article/ArticleParCategorie.css";
import { useNavigate } from "react-router-dom";

const ArticlesParCategorie = ({ category, articles = [], setLoadingVersDetails }) => {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [visitedPages, setVisitedPages] = useState([0]);

  const itemsPerPage = 5;
  const minPagesBeforeSeeMore = 2;
  const maxPage = Math.ceil(articles.length / itemsPerPage);

  const isCategoryPremium = category.type === 1;
  const listRef = useRef(null);

  const paginatedArticles = useMemo(() => {
    const pages = [];
    for (let i = 0; i < maxPage; i++) {
      pages.push(articles.slice(i * itemsPerPage, (i + 1) * itemsPerPage));
    }
    return pages;
  }, [articles, maxPage]);

  useEffect(() => {
    setVisitedPages((prev) => {
      if (prev.includes(page)) return prev;
      return [...prev, page];
    });
  }, [page]);

  useEffect(() => {
    setPage(0);
    setVisitedPages([0]);
  }, [articles, category]);

  const goNext = () => {
    if (page + 1 < maxPage && page + 1 < minPagesBeforeSeeMore) {
      setPage((p) => p + 1);
    }
  };

  const goPrev = () => {
    if (page > 0) {
      setPage((p) => p - 1);
    }
  };

  const defaultImage = `${imageArticleUrl}/files/article/default-image.png`;
  const currentUser =
    JSON.parse(localStorage.getItem("user")) ||
    JSON.parse(sessionStorage.getItem("user"));

  return (
    <div className="articlre-par-category-section">
      <h4
        className={`articlre-par-category-title ${
          isCategoryPremium ? "premium-category-title" : ""
        }`}
      >
        <a
          href={`/article/resultat?categorie=${category.numeroComponent}`}
          className="articlre-par-category-nom"
          onClick={(e) => {
            e.preventDefault();
            navigate(`/article/resultat?categorie=${category.numeroComponent}`);
          }}
        >
          {category.nom}
        </a>
      </h4>

      <div className="articlre-par-category-horizontal-container">
        {page > 0 && (
          <div className="articlre-par-category-arrow-button left-arrow" onClick={goPrev}>
            <div className="articlre-par-category-arrow" >
              <FiChevronLeft className="articlre-par-category-arrow-fleche" />
            </div>
          </div>
        )}

        <div className="articlre-par-category-pages-wrapper" ref={listRef}>
          {paginatedArticles.map((pageArticles, pageIndex) => {
            if (!visitedPages.includes(pageIndex) && pageIndex !== page) {
              return null;
            }

            const isCurrentPage = pageIndex === page;
            const isLastPage = pageIndex + 1 === minPagesBeforeSeeMore;
            const isFullLastPage = isLastPage && pageArticles.length === itemsPerPage;

            return (
              <div
                key={`page-${pageIndex}`}
                className={`articlre-par-category-horizontal-list ${
                  isCurrentPage ? "active-page" : "hidden-page"
                }`}
              >
                {pageArticles.map((a, index) => {
                  const isFavori = a.nbFavoris?.some(
                    (u) => u.toString() === currentUser?._id
                  );

                  if (
                    isLastPage &&
                    isFullLastPage &&
                    index === itemsPerPage - 1
                  ) {
                    return (
                      <motion.div
                        key="see-more-card"
                        whileHover={{ scale: 1.02 }}
                        className="article-card-v3 see-more-card"
                      >
                        <a
                          onClick={(e)=>{
                            e.stopPropagation();
                            setLoadingVersDetails(true);
                            window.scrollTo({ top: 0, behavior: "smooth" });
                            setTimeout(() => {
                              navigate(`/article/resultat?categorie=${category.numeroComponent}`);
                            }, 2000);
                          }}                          
                          style={{ cursor: "pointer" }}
                        >
                          <div className="see-more-card-content">
                            <FiChevronRight size={32} className="see-more-icon" />
                            <p>Voir plus d’annonces</p>
                          </div>
                        </a>
                      </motion.div>
                    );
                  }

                  return (
                    <ArticleCarte
                      key={a._id || `${pageIndex}-${index}`}
                      article={a}
                      imageUrl={
                        a.photos?.[0]
                          ? `${imageArticleUrl}/${a.photos[0]}`
                          : defaultImage
                      }
                      isFavori={isFavori}
                      favorisCount={a.nbFavorisCount || 0}
                      setLoadingVersDetails={setLoadingVersDetails}
                    />
                  );
                })}
              </div>
            );
          })}
        </div>

        {page + 1 < maxPage && page + 1 < minPagesBeforeSeeMore && (
          <div className="articlre-par-category-arrow-button right-arrow" onClick={goNext}>
            <div className="articlre-par-category-arrow">
              <FiChevronRight className="articlre-par-category-arrow-fleche" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ArticlesParCategorie;